import { DateTime } from 'luxon';
// Extends a window's end time by durationPercentage, based on the window's total configured span
// (ends_at - starts_at) rather than time-remaining-from-now, so the extension is deterministic
// regardless of when it's evaluated. Only ends_at changes — starts_at (window opening) is untouched.
export const extendWindowEnd = (actionWindow, durationPercentage) => {
    if (!actionWindow?.ends_at || !actionWindow?.starts_at || !durationPercentage)
        return actionWindow;
    const windowStart = DateTime.fromISO(actionWindow.starts_at);
    const windowEnd = DateTime.fromISO(actionWindow.ends_at);
    if (!windowStart.isValid || !windowEnd.isValid)
        return actionWindow;
    const originalDurationMs = windowEnd.diff(windowStart).as('milliseconds');
    const extendedDurationMs = originalDurationMs * (1 + durationPercentage / 100);
    const extendedEnd = windowStart.plus({ milliseconds: extendedDurationMs });
    return { ...actionWindow, ends_at: extendedEnd.toISO() ?? actionWindow.ends_at };
};
export const getWindowConstrainedTime = (sectionTime, actionWindow, durationPercentage) => {
    const effectiveWindow = extendWindowEnd(actionWindow, durationPercentage);
    if (!effectiveWindow?.ends_at)
        return sectionTime;
    const windowEnd = DateTime.fromISO(effectiveWindow.ends_at);
    if (!windowEnd.isValid)
        return sectionTime;
    const windowRemainingSeconds = Math.max(0, Math.floor(windowEnd.diffNow().as('seconds')));
    return sectionTime > 0 ? Math.min(windowRemainingSeconds, sectionTime) : windowRemainingSeconds;
};
